<div class="grid-class">
	<div class="dz-row dz-justify-content-left-md dz-justify-content-center-sm dz-justify-content-center dz-align-items-bottom">
		<ng-container *ngFor="let filter of displayFiltersList; trackByFields: 'id'">
			<mb-models-experience-dropdown
				[filter]="filter"
				[ngClass]="getWidthClass(filter)"
				(getSelectedFilters)="getSelectedFiltersList($event)"
				class="dz-block dz-col-md-8 margin-bottom-object-2"
			></mb-models-experience-dropdown>
		</ng-container>
		<span
			class="dz-col-xl-2 dz-col-lg-2 dz-flex-md dz-justify-content-left dz-align-items-bottom padding-bottom-object-1 icon dz-hidden"
			(click)="toggleView()"
			*ngIf="showDropDownFiltersMoreLessBtn"
		>
			<span *ngIf="showMore">
				<dz-icon type="plus"></dz-icon>
				<span class="dz-text-14">More</span>
			</span>
			<span *ngIf="!showMore">
				<dz-icon type="minus"></dz-icon>
				<span class="dz-text-14">Less</span>
			</span>
		</span>
	</div>
</div>
